var Vendd = (function (Vendd) {
	'use strict';
    
	

	var model = null;
	var pending = false;

	Vendd.MessageBus.subscribe(Vendd.WishlistMerchant.Messages.GetModel, Vendd.WishlistMerchant, function (envelope) {

	    if (pending === true) {
	        return false;
	    };

	    pending = true;

	    function onSuccess(response) {
	        model = response.data;

	        Vendd.MessageBus.publishAsync(Vendd.WishlistMerchant, new Vendd.WishlistMerchant.Messages.Changed(model));

	        pending = false;
	    }

	    function onFailure(response) {
	        console.log("Vendd.MessageBus.subscribe fail");
	        Vendd.MessageBus.publishAsync(Vendd.WishlistMerchant, new Vendd.WishlistMerchant.Messages.Failed(response));
	    }

	    var options = {
	        url: 'api/Wishlist/GetWishlistMerchantViewModel',
	        onSuccess: onSuccess,
	        onFailure: onFailure
	    };

	    Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.WishlistMerchant.Messages.Add, Vendd.WishlistMerchant, function (envelope) {
	    var data = {};
	    data.item = envelope.message.data;

	    function onSuccess(response) {
	        if (response.success)
	            Vendd.MessageBus.publishAsync(Vendd.WishlistMerchant, new Vendd.WishlistMerchant.Messages.GetModel());
	        else
	            Vendd.MessageBus.publishAsync(Vendd.WishlistMerchant, new Vendd.WishlistMerchant.Messages.Failed(response));
        }

	    function onFailure(response) {
	        console.log("fail response:" + JSON.stringify(response));
	        Vendd.MessageBus.publishAsync(Vendd.WishlistMerchant, new Vendd.WishlistMerchant.Messages.Failed(response));
	    }

	    var options = {
	        url: 'EcomService.svc/AddToWishlistMerchant',
	        data: data,
	        onSuccess: onSuccess,
	        onFailure: onFailure
	    };

	    Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.WishlistMerchant.Messages.Remove, Vendd.WishlistMerchant, function (envelope) {
	    function onSuccess(response) {
            if (response.success)
                Vendd.MessageBus.publishAsync(Vendd.WishlistMerchant, new Vendd.WishlistMerchant.Messages.GetModel());
            else
                Vendd.MessageBus.publishAsync(Vendd.WishlistMerchant, new Vendd.WishlistMerchant.Messages.Failed(response));
        }

	    function onFailure(response) {
	        console.log("fail response:" + JSON.stringify(response));
	        Vendd.MessageBus.publishAsync(Vendd.WishlistMerchant, new Vendd.WishlistMerchant.Messages.Failed(response));
        }

        var options = {
            url: 'EcomService.svc/RemoveFromWishlistMerchant',
            data: envelope.message.data,
            onSuccess: onSuccess,
            onFailure: onFailure
        };

		Vendd.Service.call(options);
	});

	Vendd.MessageBus.subscribe(Vendd.WishlistMerchant.Messages.Clear, Vendd.WishlistMerchant, function (envelope) {
        function onSuccess (response) {
            if (response.success)
                Vendd.MessageBus.publishAsync(Vendd.WishlistMerchant, new Vendd.WishlistMerchant.Messages.GetModel());
            else
                Vendd.MessageBus.publishAsync(Vendd.WishlistMerchant, new Vendd.WishlistMerchant.Messages.Failed(response));
        }

        function onFailure (response) {
            Vendd.MessageBus.publishAsync(Vendd.WishlistMerchant, new Vendd.WishlistMerchant.Messages.Failed(response));
        }

        var options = {
            url: 'EcomService.svc/ClearWishlistMerchant',
            onSuccess: onSuccess,
            onFailure: onFailure
        };

		Vendd.Service.call(options);
	});

	var dontLoadOnLoginSuccess;
	Vendd.MessageBus.subscribe(Vendd.User.Messages.Login, Vendd.WishlistMerchant, function (envelope) {
		dontLoadOnLoginSuccess = envelope.message.data.options && envelope.message.data.options.isLoginForm;
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.LoginSuccess, Vendd.WishlistMerchant, function (envelope) {
		if (dontLoadOnLoginSuccess)
			return;
	    Vendd.MessageBus.publishAsync(Vendd.WishlistMerchant, new Vendd.WishlistMerchant.Messages.GetModel());
	});

	Vendd.MessageBus.subscribe(Vendd.User.Messages.LogoutSuccess, Vendd.WishlistMerchant, function (envelope) {
		if (dontLoadOnLoginSuccess)
			return;
	    Vendd.MessageBus.publishAsync(Vendd.WishlistMerchant, new Vendd.WishlistMerchant.Messages.GetModel());
	});

	return Vendd;

})(Vendd || {});